import React from 'react';
import {FormattedMessage} from 'react-intl';
import Aux from '../hoc/auxi';


const admin = (props) => {
    //console.log("props.medValue ----->" + props.medValue);
    //console.log("props----> " + JSON.stringify(props));
    let smokerV = null;
    let smokers = null;

    smokerV = (
        <div className="form-group">
            <label htmlFor="smoker_status"><FormattedMessage id="smoker-status-edit"/></label>
            <select className="form-control" defaultValue={"DEFAULT"} onChange={props.smokersVSelected}>
                <option value="DEFAULT" disabled>Situação neste momento</option>
                <option value="">Não respondeu</option>
                {props.smokersVSelect}


                {/*
                <option selected disabled><label className="form-text text-muted mb-3">Situação neste momento</label>
                </option>
*/}
            </select>
        </div>

    );
    if (props.smokers === "1") {
        smokers = (<div>
{/*            <div className="form-group">
                <label htmlFor="smoker_status"><FormattedMessage id="smoker-status-edit"/></label>
                <select className="form-control" onChange={props.smokersVSelected}>
                    <option selected disabled><label className="form-text text-muted mb-3">Situação neste
                        momento</label></option>
                    <option value="">Não respondeu</option>
                    {props.smokersVSelect}
                </select>
            </div>*/}
            <div className="form-group">
                <label htmlFor="regularity"><FormattedMessage id="regularity-edit"/></label>
                <select className="form-control" defaultValue={"DEFAULT"} onChange={props.smokersFSelected}>
                    <option value="DEFAULT" disabled>Regularidade</option>
                    <option value="">Não respondeu</option>
                    {props.smokersFSelect}
                </select>
            </div>
            <div className="form-group">
                <label htmlFor="regularity">Tipo: </label>
                <select className="form-control" defaultValue={"DEFAULT"}>
                    <option value="DEFAULT" disabled>Tipo</option>
                    <option value="">Não respondeu</option>
                    {props.smokersTSelect}
                </select>
            </div>
            <div className="form-group">
                <label htmlFor="average_number"><FormattedMessage id="amount"/></label>
                <input type="number" step='1' id="inputEmail" min="1" max="999"
                       style={{padding: "10px", width: "300px"}} placeholder="Nº médio de acordo com o seu hábito"
                       className="form-control" onChange={props.smokersA}/>

                {/*<select className="form-control" onChange={props.smokersASelected}>
                    <option selected disabled><label className="form-text text-muted mb-3">Nº médio de acordo com o seu hábito</label>
                    </option>
                    <option value="">Não respondeu</option>
                    {props.smokersASelect}
                </select>*/}
            </div>

        </div>);
    }

    /*
    * */
    let chronic = '';

    if (props.chronicValue === '1') {

        chronic = <div className="form-group">Indique quais:
            {props.chronicOSelect}</div>
        ;
    }

    let med = '';

    if (props.medValue === '1') {

        med = (<div>
            <div className="form-group">

                <label htmlFor="number"><FormattedMessage id="meds-number-edit"/></label>
                <input type="number" id="inputEmail" min="0" style={{padding: "10px", width: "300px"}}
                       placeholder="Se sim, indique o nº de fármacos diferentes que toma por dia"
                       className="form-control" onChange={props.medsNChange}/>
            </div>
            Indique quais:
            {props.medsSelect}
        </div>);
    }

    let pain ='';

    if(props.painVSelected === '2' || props.painVSelected === '3'){
        pain = (
            <div> <script>alert(11);</script>
                <div className="form-group" style={{marginBottom: "0"}}>Indique o local onde a dor é mais elevada:
                {props.painLSelect}
                </div>
                <div>Classifique a intensidade média da dor</div>
                {props.painSSelect}
            </div>
        );
    }

    let physical = '';
    if (props.physicalValue === '1') {
        physical = (
                <div className="form-group">
                    <div>
                        Indique quais:
                        {props.physicalVSelect}
                    </div>
                    <div className="form-group">
                        <label htmlFor="physical_options">Em média, quanto tempo</label>
                        <select className="form-control" defaultValue={"DEFAULT"} onChange={props.physicalVSelected}>
                            <option value="DEFAULT" disabled>Em média, quanto tempo</option>
                            <option value="">Não respondeu</option>
                            {props.physicalHSelect}
                        </select>
                    </div>
                </div>
        );


/*        physical = (
            <div>
                <div className="form-group">
                    <label htmlFor="physical_options">Indique qual:</label>
                    <select className="form-control" defaultValue={"DEFAULT"} onChange={props.physicalVSelected}>
                        <option value="DEFAULT" disabled>Indique qual</option>
                        <option value="">Não respondeu</option>
                        {props.physicalVSelect}
                    </select>
                </div>
                <div className="form-group">
                    <label htmlFor="physical_options">Em média, quanto tempo</label>
                    <select className="form-control" defaultValue={"DEFAULT"} onChange={props.physicalVSelected}>
                        <option value="DEFAULT" disabled>Em média, quanto tempo</option>
                        <option value="">Não respondeu</option>
                        {props.physicalHSelect}
                    </select>
                </div>

            </div>
        );*/
    }

    let alcohol = '';
    if (props.alcoholValue === '1') {

        alcohol = (<Aux>
            <div className="form-group">
                <label htmlFor="beer"><FormattedMessage id="beers"/></label>
                <input type="number" step="1" min="0" id="beer" onChange={props.beerChange}/>
            </div>
            <div className="form-group">
                <label htmlFor="wine"><FormattedMessage id="wine"/></label>
                <input type="number" step="1" min="0" id="wine" onChange={props.wineChange}/>
            </div>
            <div className="form-group">
                <label htmlFor="spirit_drinks"><FormattedMessage id="spirit_drinks"/></label>
                <input type="number" step="1" min="0" id="spirit_drinks" onChange={props.spiritDrinksChange}/>
            </div>
        </Aux>)
        ;
    }

    let spiro = '';
    if (props.spiroValue === '1') {
        spiro = <div className="form-group">Alterações:
            {props.spiroSelect}</div>
        ;

/*        spiro = (<div>
            <select className="form-control" defaultValue="Alteração" onChange={props.spiroSelected}>
                <option disabled><label className="form-text text-muted mb-3">Alteração</label></option>
                {props.spiroSelect}
            </select>
        </div>)*/
    }
    let visual = '';
    if (props.visualValue === '1') {
        visual = <div className="form-group">Alterações:
            {props.visualSelect}</div>
        ;
/*        visual = (<div>
            <select className="form-control" defaultValue="Alteração" onChange={props.visualSelected}>
                <option disabled><label className="form-text text-muted mb-3">Alteração</label></option>
                {props.visualSelect}
            </select>
        </div>)*/
    }
    let auditory = '';
    if (props.auditoryValue === '1') {
        auditory = <div className="form-group">Alterações:
            {props.auditorySelect}</div>
        ;
/*        auditory = (<div>
            <select className="form-control" defaultValue="Alteração" onChange={props.auditorySelected}>
                <option disabled><label className="form-text text-muted mb-3">Alteração</label></option>
                {props.auditorySelect}
            </select>
        </div>)*/
    }
    let ecg = '';
    if (props.ecgValue === '1') {
        ecg = <div className="form-group">Alterações:
            {props.ecgSelect}</div>
        ;
/*        ecg = (<div>
            <select className="form-control" defaultValue="Alteração" onChange={props.ecgSelected}>
                <option disabled><label className="form-text text-muted mb-3">Alteração</label></option>
                {props.ecgSelect}
            </select>
        </div>)*/
    }
    let eritrogram = '';
    if (props.eritrogramValue === '1') {
        eritrogram = <div className="form-group">Alterações:
            {props.eritrogramSelect}</div>
        ;

        /*eritrogram = (<div>
            <select className="form-control" defaultValue="Alteração" onChange={props.eritrogramSelected}>
                <option disabled><label className="form-text text-muted mb-3">Alteração</label></option>
                {props.eritrogramSelect}
            </select>
        </div>)*/
    }
    let leukogram = '';
    if (props.leukogramValue === '1') {
        leukogram = <div className="form-group">Alterações:
            {props.leukogramSelect}</div>
        ;

      /*  leukogram = (<div>
            <select className="form-control" defaultValue="Alteração" onChange={props.leukogramSelected}>
                <option disabled><label className="form-text text-muted mb-3">Alteração</label></option>
                {props.leukogramSelect}
            </select>
        </div>)*/
    }

    /*    console.log("message: " + props.alcoholValue)
        console.log("sdas: " + props.beerChange)
        console.log("pain: " +  props.painSSelect);
        console.log("meal:" + props.mealSelect);*/
    return (
        <Aux>
            <div className="text-center container mt-6 col-12">
                {props.message}
            </div>
            <div className="container col-12">
                <h3 className="text-secondary mb-3">Inserir novo questionário</h3>
                {/*<hr></hr>*/}
                <form className="form-insert" id="quest" name="quest" onSubmit={props.submit}>

                    {/*--------------------- DADOS SOCIO-DEMOGRÁFICOS ---------------------*/}

                    <div className="form-group">
                        <label htmlFor="text" className="sr-only">Código</label>
                        <input type="text" style={{padding: "10px"}} placeholder="Código"
                               className="form-control" onChange={props.codeChange} value={props.codeValue} required/>
                    </div>
                    <h4 className="text-primary font-weight-normal">Dados sócio-demográficos</h4>
                        <div className="form-group">
                        <div><label htmlFor="gender"><FormattedMessage id="gender"/></label></div>
                        {props.genderSelect}

                    </div>
                    <div className="form-group">
                        <label htmlFor="department"><FormattedMessage id="department"/></label>
                        <select className="form-control" defaultValue="Departamento, Escola ou Serviço"
                                onChange={props.depSelected}>
                           {/* <option disabled><label className="form-text text-muted mb-3">Departamento, Escola ou
                                Serviço</label></option>*/}
                            <option disabled>Departamento, Escola ou Serviço</option>
                            <option value="">Não respondeu</option>
                            {props.depSelect}
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="age"><FormattedMessage id="age"/></label>
                        <select className="form-control" defaultValue="Idade" onChange={props.ageSelected}>
                            {/*<option disabled><label className="form-text text-muted mb-3">Idade</label></option>*/}
                            <option disabled>Idade</option>
                            <option value="">Não respondeu</option>
                            {props.ageSelect}
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="marital"><FormattedMessage id="marital-status"/></label>
                        <select className="form-control" defaultValue="Estado Civil" onChange={props.maritalSelected}>
                            {/*<option disabled><label className="form-text text-muted mb-3">Estado Civil</label></option>*/}
                            <option disabled>Estado Civil</option>
                            <option value="">Não respondeu</option>
                            {props.maritalSelect}
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="academic"><FormattedMessage id="academic"/></label>
                        <select className="form-control" defaultValue="Habilitações Literárias"
                                onChange={props.academicSelected}>
                            {/*<option disabled><label className="form-text text-muted mb-3">Habilitações
                                Literárias</label></option>*/}
                            <option disabled>Habilitações Literárias</option>
                            <option value="">Não respondeu</option>
                            {props.academicSelect}
                        </select>
                    </div>

                    {/*--------------------- HÁBITOS TABÁGICOS E DE SAÚDE ---------------------*/}
                    <h4 className="text-primary font-weight-normal">Hábitos tabágicos e de saúde</h4>
                    {smokerV}
                    {smokers}
                    <div className="form-group">
                        <label htmlFor="health_opinion"><FormattedMessage id="health-opinion"/></label>
                        <select className="form-control" defaultValue="Como classifica a sua saúde"
                                onChange={props.healthOSelected}>
                            {/*<option disabled><label className="form-text text-muted mb-3">Como classifica a sua
                                saúde</label></option>*/}
                            <option disabled>Como classifica a sua saúde</option>
                            <option value="">Não respondeu</option>
                            {props.healthOSelect}
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="number"><FormattedMessage id="weight"/></label>
                        <input type="number" step='0.5' id="inputEmail" min="30" max="999"
                               style={{padding: "10px", width: "300px"}} placeholder="Peso (kg)"
                               className="form-control" onChange={props.pesoChange}/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="number"><FormattedMessage id="height"/></label>
                        <input type="number" step='0.01' id="inputEmail" min="0.5" max="2.50"
                               style={{padding: "10px", width: "300px"}} placeholder="Altura (m)"
                               className="form-control" onChange={props.alturaChange}/>
                    </div>

                    <div className="form-group">
                        <label htmlFor="number"><FormattedMessage id="sleep-hours"/></label>
                        <input type="number" step='0.5' id="number" min="0" max="24"
                               style={{padding: "10px", width: "300px"}} placeholder="Horas de sono"
                               className="form-control" onChange={props.sleepChange}/>
                    </div>

                    <div className="form-group">
                        <label htmlFor="sleep_opinion"><FormattedMessage id="sleep-opinion"/></label>
                        <select className="form-control" defaultValue="Como classifica o seu sono"
                                onChange={props.sleepOSelected}>
                            {/*<option disabled><label className="form-text text-muted mb-3">Qualidade do sono</label></option>*/}
                            <option disabled>Qualidade do sono</option>
                            <option value="">Não respondeu</option>
                            {props.sleepOSelect}
                        </select>
                    </div>


                    {/*--------------------- DOENÇAS E DOR ---------------------*/}
                    <h4 className="text-primary font-weight-normal">Doença e dor</h4>
                    <div className="form-group">
                        <p style={{marginBottom: "-2px", fontWeight: "bold"}}>É portador de alguma doença crónica?</p>

                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2"
                                   value="0" checked={props.chronicValue === '0'}
                                   onChange={props.chronicChange}/>
                            <label className="form-check-label" htmlFor="inlineRadio2">Não</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1"
                                   value="1" checked={props.chronicValue === '1'}
                                   onChange={props.chronicChange}/>
                            <label className="form-check-label" htmlFor="inlineRadio1">Sim</label>
                        </div>
                        {chronic}
                    </div>

                    <div className="form-group">
                        <p style={{marginBottom: "-2px", fontWeight: "bold"}}>Toma regularmente algum fármaco?</p>

                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="inlineRadioOptions2"
                                   id="inlineRadio2" value="0" checked={props.medValue === '0'}
                                   onChange={props.medChange}/>
                            <label className="form-check-label" htmlFor="inlineRadio2">Não</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="inlineRadioOptions2"
                                   id="inlineRadio1" value="1" checked={props.medValue === '1'}
                                   onChange={props.medChange}/>
                            <label className="form-check-label" htmlFor="inlineRadio1">Sim</label>
                        </div>
                        {med}
                    </div>

                    <div className="form-group">
                        <p style={{marginBottom: "-2px", fontWeight: "bold"}}>Classifique a sua dor</p>
                        {props.painVSelect}
                        {pain}
                        { /* <div className="form-group" style={{marginBottom: "0"}}>
                            <select className="form-control" defaultValue="Indique o local onde a dor é mais elevada"
                                    onChange={props.painLSelected}>
                                <option disabled><label className="form-text text-muted mb-3">Indique o local onde a dor
                                    é mais elevada</label></option>
                                <option value="">Não respondeu</option>
                                {props.painLSelect}
                            </select>
                        </div>
                        <div>Classifique a intensidade média da dor</div>
                        {props.painSSelect}*/}
                    </div>


                    {/*--------------------- HÁBITOS ALIMENTARES ---------------------*/}
                    <h4 className="text-primary font-weight-normal">Hábitos alimentares</h4>
                    <div className="form-group">
                        <div>
                            <label htmlFor="meals"><FormattedMessage id="meals"/>
                            </label>
                        </div>
                        {props.mealSelect}
                    </div>

                    {  /* <div className="form-group">
                         <label htmlFor="meals"><FormattedMessage id="meals"/></label>
                         <select className="form-control" defaultValue=""
                                 onChange={props.mealSelected}>
                             <option disabled><label className="form-text text-muted mb-3"></label></option>
                             <option value="">Não respondeu</option>
                             {props.mealSelect}
                         </select>
                     </div>*/}

                    <div className="form-group">
                        <div>
                            <label htmlFor="breakfast"><FormattedMessage id="breakfast"/>
                            </label>
                        </div>
                        {props.breakfastSelect}
                    </div>
                    {/*<div className="form-group">
                        <label htmlFor="breakfast"><FormattedMessage id="breakfast"/></label>
                        <select className="form-control"
                                defaultValue=""
                                onChange={props.breakfastSelected}>
                            <option disabled><label className="form-text text-muted mb-3"></label></option>
                            <option value="">Não respondeu</option>
                            {props.breakfastSelect}
                        </select>
                    </div>*/}
                    <div className="form-group">
                        <div>
                            <label htmlFor="fruit"><FormattedMessage id="fruit"/></label>
                        </div>
                        {props.fruitSelect}
                    </div>

                    {/*                    <div className="form-group">
                        <label htmlFor="fruit"><FormattedMessage id="fruit"/></label>
                        <select className="form-control" defaultValue=""
                                onChange={props.fruitSelected}>
                            <option disabled><label className="form-text text-muted mb-3"></label></option>
                            <option value="">Não respondeu</option>
                            {props.fruitSelect}
                        </select>
                    </div>*/}

                    <div className="form-group">
                        <div>
                            <label htmlFor="vegetables"><FormattedMessage id="vegetables"/></label>
                        </div>
                        {props.vegetableSelect}
                    </div>

                    {/*                    <div className="form-group">
                        <label htmlFor="vegetables"><FormattedMessage id="vegetables"/></label>
                        <select className="form-control"
                                defaultValue=""
                                onChange={props.vegetableSelected}>
                            <option disabled><label className="form-text text-muted mb-3"></label></option>
                            <option value="">Não respondeu</option>
                            {props.vegetableSelect}
                        </select>
                    </div>*/}

                    <div className="form-group">
                        <div>
                            <label htmlFor="sodas"><FormattedMessage id="sodas"/></label>
                        </div>
                        {props.sodaSelect}
                    </div>

                    {/*<div className="form-group">
                        <label htmlFor="sodas"><FormattedMessage id="sodas"/></label>
                        <select className="form-control"
                                defaultValue=""
                                onChange={props.sodaSelected}>
                            <option disabled><label className="form-text text-muted mb-3"></label></option>
                            <option value="">Não respondeu</option>
                            {props.sodaSelect}
                        </select>
                    </div>*/}

                    <div className="form-group">
                        <div>
                            <label htmlFor="fast_food"><FormattedMessage id="fast-food"/></label>
                        </div>
                        {props.fastFSelect}
                    </div>

                    {/* <div className="form-group">
                        <label htmlFor="fast_food"><FormattedMessage id="fast-food"/></label>
                        <select className="form-control"
                                defaultValue=""
                                onChange={props.fastFSelected}>
                            <option disabled><label className="form-text text-muted mb-3"></label></option>
                            <option value="">Não respondeu</option>
                            {props.fastFSelect}
                        </select>
                    </div>*/}

                    <div className="form-group">
                        <label htmlFor="alcohol"><FormattedMessage id="alcohol-edit"/></label>
                        <div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="inlineRadioOptions_alcohol" id="inlineRadio_alcohol"
                                       value="0" checked={props.alcoholValue === '0'}
                                       onChange={props.alcoholChange}/>
                                <label className="form-check-label" htmlFor="inlineRadio_alcohol">Não</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="inlineRadioOptions_alcohol" id="inlineRadio_alcohol2"
                                       value="1" checked={props.alcoholValue === '1'}
                                       onChange={props.alcoholChange}/>
                                <label className="form-check-label" htmlFor="inlineRadio_alcohol2">Sim</label>
                            </div>
                        </div>
                        {alcohol}
                    </div>

                    {/*                    <div className="form-group">
                        <div className="form-group">
                            <label htmlFor="alcohol"><FormattedMessage id="alcohol-edit"/></label>
                            <select className="form-control" id="alcohol" defaultValue="" onChange={props.alcoholChange}
                                    value={props.alcoholValue}>
                                <option disabled><label className="form-text text-muted mb-3"></label></option>
                                <option value="null"><FormattedMessage id="no-answer"/></option>
                                <option value="0"><FormattedMessage id="no"/></option>
                                <option value="1"><FormattedMessage id="yes"/></option>
                            </select>
                        </div>
                        {alcohol}
                    </div>*/}

                    {/*---------------------- EXERCICIO FÍSICO --------------------------*/}
                    <h4 className="text-primary font-weight-normal">Exercício físico</h4>
                    <p style={{marginBottom: "-2px", fontWeight: "bold"}}>Pratica desporto/exercício físico
                        programado?</p>

                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioOptions5" id="inlineRadio2"
                               value="0" checked={props.physicalValue === '0'}
                               onChange={props.physicalChange}/>
                        <label className="form-check-label" htmlFor="inlineRadio2">Não</label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="inlineRadioOptions5" id="inlineRadio1"
                               value="1" checked={props.physicalValue === '1'}
                               onChange={props.physicalChange}/>
                        <label className="form-check-label" htmlFor="inlineRadio1">Sim</label>
                    </div>
                    {physical}

                    <p style={{marginBottom: "-2px", fontWeight: "bold"}}>Por dia, em média, quantos minutos costuma
                        andar a pé ou de bicicleta (para ir e vir do trabalho, da escola ou fazer compras)?</p>

                    <div className="form-group">
                        <select className="form-control"
                                defaultValue="Por dia, em média, quantos minutos costuma andar a pé ou de bicicleta (para ir e vir do trabalho, da escola ou fazer compras)?"
                                onChange={props.walking_cyclingSelected}>
                            <option disabled>
                                Por dia, em média, quantos
                                minutos costuma andar a pé ou de bicicleta (para ir e vir do trabalho, da escola ou
                                fazer compras)?
                            </option>
                            <option value="">Não respondeu</option>
                            {props.walking_cyclingSelect}
                        </select>
                    </div>
                    {/*--------------------- EXAMES DE DIAGNÓSTICO ---------------------*/}
                    <h4 className="text-primary font-weight-normal">Exames de diagnóstico</h4>
                    {/*Ciclo cardiaco*/}
                    <p className="mt-3">Ciclo cardíaco</p>

                    <div className="form-group">
                        <label htmlFor="text" className="sr-only">Pressão arterial Sistólica</label>
                        <input type="number" step='1' min="0" max="999"
                               style={{padding: "10px", width: "300px"}}
                               placeholder="Pressão arterial Sistólica (mmHg)" className="form-control"
                               onChange={props.sistChange}/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="text" className="sr-only">Pressão arterial Diastólica</label>
                        <input type="number" step='1' min="0" max="999"
                               style={{padding: "10px", width: "300px"}}
                               placeholder="Pressão arterial Diastólica (mmHg)" className="form-control"
                               onChange={props.distChange}/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="text" className="sr-only">Pulso</label>
                        <input type="number" step='1' min="0" max="999"
                               style={{padding: "10px", width: "300px"}}
                               placeholder="Pulso (ppm)" className="form-control"
                               onChange={props.pulseChange}/>
                    </div>

                    {/*Bioquimica*/}
                    <p className="mt-3">Bioquímica</p>

                    <div className="form-group">
                        <label htmlFor="text" className="sr-only">Ácido úrico</label>
                        <input type="number" step='0.1' min="0" max="99.9"
                               style={{padding: "10px", width: "300px"}}
                               placeholder="Ácido úrico (mg/dl)" className="form-control"
                               onChange={props.uricChange}/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="text" className="sr-only">Glicose</label>
                        <input type="number" step='1' min="0" max="999"
                               style={{padding: "10px", width: "300px"}}
                               placeholder="Glicose (mg/dl)" className="form-control"
                               onChange={props.glucoseChange}/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="text" className="sr-only">Colesterol total</label>
                        <input type="number" step='1' min="0" max="999"
                               style={{padding: "10px", width: "300px"}}
                               placeholder="Colestherol total (mg/dl)" className="form-control"
                               onChange={props.colestherolChange}/>
                    </div>
                    <div className="form-group">
                        <p style={{marginBottom: "-2px", fontWeight: "bold"}}>Espirometria</p>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="inlineRadioOptions6"
                                   id="inlineRadio1" value="0" checked={props.spiroValue === '0'}
                                   onChange={props.spiroChange}/>
                            <label className="form-check-label" htmlFor="inlineRadio1">Normal</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="inlineRadioOptions6"
                                   id="inlineRadio2" value="1" checked={props.spiroValue === '1'}
                                   onChange={props.spiroChange}/>
                            <label className="form-check-label" htmlFor="inlineRadio2">Alterado</label>
                        </div>
                        {spiro}
                    </div>
                    <div className="form-group">
                        <p style={{marginBottom: "-2px", fontWeight: "bold"}}>Rastreio Visual</p>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="inlineRadioOptions7"
                                   id="inlineRadio1" value="0" checked={props.visualValue === '0'}
                                   onChange={props.visualChange}/>
                            <label className="form-check-label" htmlFor="inlineRadio1">Normal</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="inlineRadioOptions7"
                                   id="inlineRadio2" value="1" checked={props.visualValue === '1'}
                                   onChange={props.visualChange}/>
                            <label className="form-check-label" htmlFor="inlineRadio2">Alterado</label>
                        </div>
                        {visual}
                    </div>
                    <div className="form-group">
                        <p style={{marginBottom: "-2px", fontWeight: "bold"}}>Rastreio Auditivo</p>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="inlineRadioOptions8"
                                   id="inlineRadio1" value="0" checked={props.auditoryValue === '0'}
                                   onChange={props.auditoryChange}/>
                            <label className="form-check-label" htmlFor="inlineRadio1">Normal</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="inlineRadioOptions8"
                                   id="inlineRadio2" value="1" checked={props.auditoryValue === '1'}
                                   onChange={props.auditoryChange}/>
                            <label className="form-check-label" htmlFor="inlineRadio2">Alterado</label>
                        </div>
                        {auditory}
                    </div>
                    <div className="form-group">
                        <p style={{marginBottom: "-2px", fontWeight: "bold"}}>ECG</p>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="inlineRadioOptions9"
                                   id="inlineRadio1" value="0" checked={props.ecgValue === '0'}
                                   onChange={props.ecgChange}/>
                            <label className="form-check-label" htmlFor="inlineRadio1">Normal</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="inlineRadioOptions9"
                                   id="inlineRadio2" value="1" checked={props.ecgValue === '1'}
                                   onChange={props.ecgChange}/>
                            <label className="form-check-label" htmlFor="inlineRadio2">Alterado</label>
                        </div>
                        {ecg}
                    </div>
                    <div className="form-group">
                        <p style={{marginBottom: "-2px", fontWeight: "bold"}}>Eritograma</p>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="inlineRadioOptions10"
                                   id="inlineRadio1" value="0" checked={props.eritrogramValue === '0'}
                                   onChange={props.eritrogramChange}/>
                            <label className="form-check-label" htmlFor="inlineRadio1">Normal</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="inlineRadioOptions10"
                                   id="inlineRadio2" value="1" checked={props.eritrogramValue === '1'}
                                   onChange={props.eritrogramChange}/>
                            <label className="form-check-label" htmlFor="inlineRadio2">Alterado</label>
                        </div>
                        {eritrogram}
                    </div>
                    <div className="form-group">
                        <p style={{marginBottom: "-2px", fontWeight: "bold"}}>Leucograma</p>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="inlineRadioOptions11"
                                   id="inlineRadio1" value="0" checked={props.leukogramValue === '0'}
                                   onChange={props.leukogramChange}/>
                            <label className="form-check-label" htmlFor="inlineRadio1">Normal</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="inlineRadioOptions11"
                                   id="inlineRadio2" value="1" checked={props.leukogramValue === '1'}
                                   onChange={props.leukogramChange}/>
                            <label className="form-check-label" htmlFor="inlineRadio2">Alterado</label>
                        </div>
                        {leukogram}
                    </div>
                    <button className="btn btn-lg btn-primary btn-block mt-4 text-white" type="submit">Enviar</button>
                </form>
            </div>
        </Aux>
    )
};

export default admin;



// WEBPACK FOOTER //
// ./src/components/admin.js